import LotteryCoreJSON from './LotteryCore.json';
import TicketManagerJSON from './TicketManager.json';

// Extract just the ABI from the JSON files
export const LotteryCoreABI = LotteryCoreJSON.abi;
export const TicketManagerABI = TicketManagerJSON.abi;
